<template>
	<el-dialog :visible.sync="lemon" class="dia" width="882px" :before-close="chatClose">
		<!-- <lemon-imui ref="IMUI" :user="user" theme="blue" @send="handleSend" @pull-messages='handlePullMessages'
			@getCurrentContact="getCurrentContact" @change-contact="changeContact" /> -->
	</el-dialog>
</template>
<script>
	// import socket from "@/websocket/chatSocket";
	import emoji from "@/utils/emoji.js";
	import {
		getChatRecord,
		getChatManage
	} from "@/service/printApi.js";
	// @ is an alias to /src
	export default {
		name: "home",
		//   components: { webIndex },
		data() {
			var _this = this;
			return {
				lemon: false,
				userList: [],
				contact: [],
				taskObj: {
					//传递任务面板对象
					type: "all",
				},
				taskPanelVisible: false,
				iframeData: {}, //iframe对象
				pathFlag: "",
				userId: "",
				toId: '',
				user: {},
			};
		},
		mounted() {
			socket.createSocket(socket.wsUrl);
			console.log(socket)
			window.addEventListener('onmessageWS', this.getSocketData)
		},
		computed: {},
		watch: {
		},
		methods: {
			// 收到消息处理
			getSocketData(res) {
				console.log(res.detail.data)
				let newData = JSON.parse(res.detail.data)
				const data = {
					id: '123',
					status: 'succeed',
					type: 'text',
					sendTime: newData.createDate,
					content: newData.content,
					toContactId: newData.toId,
					fromUser: {
						//如果 id == this.user.id消息会显示在右侧，否则在左侧
						id: newData.userId,
						displayName: '',
						avatar: '',
					}
				};
				let IMUI = this.$refs["IMUI"];
				// ...业务处理
				console.log(data)
				IMUI.appendMessage(data);
			},
			changeContact(contact) {
				console.log(contact)
				this.toId = contact.id
			},
			getCurrentContact(contact) {
				console.log(contact)
			},
			handlePullMessages(contact, next) {
				let params = {
					userId: this.userId,
					toId: this.toId
				}
				var token = sessionStorage.getItem("token");
				getChatRecord(params, token).then((res) => {
					if (res.status === 200) {
						// this.$message({
						// 	message: "删除成功",
						// 	type: "success",
						// });
						let messages = []
						res.data.forEach(item => {
							let user = {
								id: item.userId
							}
							messages.push(
								{
									id: '123',
									status: 'succeed',
									type: 'text',
									sendTime: item.createDate,
									content: item.content,
									toContactId: item.toId,
									fromUser: user
								}
							)
						})
						//从后端请求消息数据，包装成下面的样子

						//将第二个参数设为true，表示已到末尾，聊天窗口顶部会显示“暂无更多消息”，不然会一直转圈。
						next(messages, true);
					}
				});

			},
			chatClose() {
				this.dialogVisible = false
				socket.socketClose.close()
				console.log(socket)
				this.$emit('chatClose', this.dialogVisible)
			},
			// 聊天部分代码
			//发送消息
			handleSend(message, next, file) {
				var msg = {
					token: this.userId,
					userId: this.userId,
					toId: message.toContactId,
					content: message.content,
					type: 1,
				};
				//如果判断失败
				//执行到next消息会停止转圈，如果接口调用失败，可以修改消息的状态 next({status:'failed'});
				// socket.sendMsg(JSON.stringify(msg).replace(/\"/g, ""));
				socket.sendMsg(msg)
				console.log(JSON.stringify(msg).replace(/\"/g, ""));
				next({ status: "failed" });
				next();
			},
			//  沟通交流
			openLemo() {
				this.lemon = true;
				this.$nextTick(function () {
					let IMUI = this.$refs["IMUI"];
					this.getUserInfo();
					IMUI.initEmoji(emoji);
					// console.log('IMUI',IMUI)
					//获取登录用户的联系人列表
					this.getUserDataList(IMUI);
				});
			},
			// 获取人员列表
			async getUserDataList(IMUI) {
				let params = {
					userId: this.userId
				}
				var token = sessionStorage.getItem("token");
				getChatManage(params, token).then((res) => {
					if (res.status === 200) {
						this.userList = res.data;
						this.userList.forEach((item) => {
							var contact = {
								id: item.opmId,
								displayName: item.opmName,
								avatar: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2F30%2F29%2Fb9%2F3029b9a01ff7f1f319369ff8c81992c6.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1655622298&t=287a3c39f1b39505feb71c81db042e00",
								index: item.index,
								unread: 0,
								lastContent: IMUI.lastContentRender({ type: 'text', content: item.content }),
								//最近一条消息的发送时间
								lastSendTime: item.contentTime,
							};
							this.contact.push(contact);
						});
						console.log("contact", this.contact);
						IMUI.initContacts(this.contact);
					}
				})
			},
			//获取个人信息
			getUserInfo() {
				var info = sessionStorage.getItem("userInfo");
				if (info) {
					console.log("userInfo", JSON.parse(info));
					this.userId = JSON.parse(info).opmId;
					console.log(this.userId);
					this.user.id = this.userId;
					this.user.displayName = info.opmName;
					this.user.avatar = "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2F30%2F29%2Fb9%2F3029b9a01ff7f1f319369ff8c81992c6.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1655622298&t=287a3c39f1b39505feb71c81db042e00"
				}
			},
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			this.openLemo()
			// this.getUserDataList()
			// this.getSaveMenu()
			setInterval((item) => {
				// this.setUserLine()
			}, 36000);
		},
		//生命周期 - 挂载完成（可以访问DOM元素）

		beforeCreate() { }, //生命周期 - 创建之前
		beforeMount() { }, //生命周期 - 挂载之前
		beforeUpdate() {
			// this.getSaveMenu()
		}, //生命周期 - 更新之前
		updated() { }, //生命周期 - 更新之后
		beforeDestroy() { }, //生命周期 - 销毁之前
		destroyed() { }, //生命周期 - 销毁完成
		activated() { },
	};
</script>

<style>
	.home_iframe {
		width: 100%;
		height: 100%;
		border: 0;
		overflow: hidden;
		overflow-y: hidden;
		overflow: scroll;
	}

	.index_body_page {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.el-header {
		background-color: #b3c0d1;
		color: #333;
		line-height: 40px;
	}

	.el-aside {
		color: #333;
	}

	.el-tabs__header {
		height: 40px;
		margin: 0;
	}

	.el-tabs__content {
		flex: 1 !important;
	}

	/* .el-tabs__active-bar {
} */

	.el-tabs__item {
		padding-left: 20px !important;
	}

	.el-tabs__nav-wrap::after {
		border: none !important;
	}

	.nav-li {
		display: flex;
		align-items: center;
		font-size: 1rem;
	}

	.nav-li img {
		width: 1rem;
		height: 1rem;
		margin-right: 4px;
	}

	.dia .el-dialog__header,
	.dia .el-dialog__body {
		padding: 0 !important;
	}

	.right-menu {
		cursor: pointer;
		padding-right: 6px;
		height: 40px;
	}

	.right-menu img {
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}

	.lemon-wrapper--theme-blue .lemon-menu {
		background-color: rgb(112, 95, 161) !important;
	}

	.lemon-editor__emoji-item {
		width: 30px !important;
	}

	.lemon-message-text .lemon-message__content img {
		width: 22px !important;
	}
</style>